export default {
    "statusBar": {
        "fullscreenTitleEnter": "Plein écran",
        "fullscreenTitleExit": "Quitter le mode plein écran",
        "networkActivity": "Activité reseau"
    }
};
